namespace RedBullMOBILE360.SMSCodes {
    export interface ServiceSmsForm {
        ServiceName: Serenity.StringEditor;
        Code: Serenity.StringEditor;
        Endpoint: Serenity.StringEditor;
        XmlRequest: Serenity.TextAreaEditor;
        SoapAction: Serenity.StringEditor;
        ReturnField: Serenity.StringEditor;
        ReturnNamespace: Serenity.StringEditor;
        ReturnMsgField: Serenity.StringEditor;
    }

    export class ServiceSmsForm extends Serenity.PrefixedContext {
        static formKey = 'SMSCodes.ServiceSms';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ServiceSmsForm.init)  {
                ServiceSmsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(ServiceSmsForm, [
                    'ServiceName', w0,
                    'Code', w0,
                    'Endpoint', w0,
                    'XmlRequest', w1,
                    'SoapAction', w0,
                    'ReturnField', w0,
                    'ReturnNamespace', w0,
                    'ReturnMsgField', w0
                ]);
            }
        }
    }
}
